module.exports = __webpack_public_path__ + "img/map_jf.c2b910ce.png";